import { object, string, array } from "yup";

const validation = (showAppointersList = false) => {
  const schema = object().shape({
    designation: string().required("Designation is required"),
    idType: string().required("Id type is required"),
    directorsList: showAppointersList
      ? array()
          .required("Appointers are required")
          .min(1, "Atleast 1 appointer is required")
      : string().optional(),
  });

  return {
    schema,
    schemaInitialValues: schema.cast(),
  };
};

export default validation;
